import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // This is your main application component
import LandingPage from './LandingPage'; // This is the component you created
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

// Define your application's routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />, // Render the LandingPage component at the root
  },
  {
    path: "/app/*",
    element: <App />, // Render your main application at the /app path
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();